module.exports = __webpack_public_path__ + "img/stayFee.9aeb691f.svg";